export default {
  // 获取农资列表
  getAgriculturalList: {
    method: 'get',
    url: '/api/getAgriculturalList'
  },
  // 添加农资
  createAgricultural: {
    method: 'post',
    url: '/api/createAgricultural'
  },
  // 删除农资
  delAgricultural: {
    method: 'delete',
    url: '/api/delAgricultural'
  },
  // 添加农资出入库记录
  createAgriculturalRecord: {
    method: 'post',
    url: '/api/createAgriculturalRecord'
  },
  // 获取农资出入库记录
  getAgriculturalRecordList: {
    method: 'get',
    url: '/api/getAgriculturalRecordList'
  }
}
